'use client';

import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/store';

export default function AuthInitializer() {
    const { checkAuth, isLoading } = useAuthStore();
    const ranRef = useRef(false);

    useEffect(() => {
        if (ranRef.current) return;
        ranRef.current = true;
        // The module-level onAuthStateChange listener fires INITIAL_SESSION
        // synchronously on import and calls checkAuth(). Skip if already in-flight.
        if (!isLoading) {
            checkAuth();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
